import type { Swiper } from 'swiper';

const hasNavigation = (swiper: Swiper): boolean => {
  return Boolean(swiper?.navigation?.nextEl && swiper?.navigation?.prevEl);
};

const hasPagination = (swiper: Swiper): boolean => {
  return Boolean(swiper?.pagination?.bullets?.length);
};

const hasScrollbar = (swiper: Swiper): boolean => {
  return Boolean(swiper?.scrollbar?.el);
};

export { hasNavigation, hasPagination, hasScrollbar };
